module.exports = __webpack_public_path__ + "img/status-rank.230c9324.png";